import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314e1c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white border border-outline-color p-3 round-4 mx-3" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "打刻時間", -1))
const _hoisted_4 = { class: "text-mild text-size-14" }
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 text-weight-500" }, "勤務時間"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-mild mt-1" }, "\n            実際の勤務時間と休憩時間を入力してください。\n          ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1 text-size-14 text-mild" }, "勤務時間", -1))
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, ":", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 mt-2 text-center" }, "から", -1))
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, ":", -1))
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, ":", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 mt-2 text-center" }, "から", -1))
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-2" }, ":", -1))
const _hoisted_18 = { class: "p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_TimeInput = _resolveComponent("TimeInput")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_FormRadioGroup = _resolveComponent("FormRadioGroup")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      勤怠変更申請\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.application)
      ? (_openBlock(), _createBlock(_component_ApplicationCard, {
          key: 0,
          application: _ctx.application,
          class: "my-3 mx-3"
        }, null, 8, ["application"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.workTime), 1)
      ])
    ]),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      ref: "vObserver",
      initialValues: _ctx.formValues
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(),
          _hoisted_7,
          _createTextVNode(),
          _createVNode(_component_AppLabel, { variant: "red" }, {
            default: _withCtx(() => [
              _createTextVNode("必須")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BRow, { class: "mx-n2" }, {
            default: _withCtx(() => [
              _createVNode(_component_BCol, { class: "px-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ValidationProvider, {
                      name: "勤務開始時間(時)",
                      rules: "required",
                      vid: "startTime.hour"
                    }, {
                      default: _withCtx((validationState) => [
                        _createVNode(_component_TimeInput, {
                          modelValue: _ctx.inputValues.startTime.hour,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.startTime.hour) = $event)),
                          "validation-state": validationState,
                          max: 23,
                          onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'startTime',
                      'hour',
                      validationState.handleChange
                    )
                  ),
                          type: "text",
                          inputmode: "numeric"
                        }, null, 8, ["modelValue", "validation-state", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_9,
                    _createTextVNode(),
                    _createVNode(_component_ValidationProvider, {
                      name: "勤務開始時間(分)",
                      rules: "required",
                      vid: "startTime.minutes"
                    }, {
                      default: _withCtx((validationState) => [
                        _createVNode(_component_TimeInput, {
                          modelValue: _ctx.inputValues.startTime.minutes,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues.startTime.minutes) = $event)),
                          "validation-state": validationState,
                          max: 59,
                          onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'startTime',
                      'minutes',
                      validationState.handleChange
                    )
                  ),
                          type: "text",
                          inputmode: "numeric"
                        }, null, 8, ["modelValue", "validation-state", "onBlur"])
                      ]),
                      _: 1
                    })
                  ])
                ], undefined, true),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(_component_BCol, {
                cols: "auto",
                class: "px-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ], undefined, true),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(_component_BCol, { class: "px-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ValidationProvider, {
                      name: "勤務終了時間(時)",
                      rules: "required",
                      vid: "endTime.hour"
                    }, {
                      default: _withCtx((validationState) => [
                        _createVNode(_component_TimeInput, {
                          modelValue: _ctx.inputValues.endTime.hour,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValues.endTime.hour) = $event)),
                          "validation-state": validationState,
                          max: 23,
                          onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'endTime',
                      'hour',
                      validationState.handleChange
                    )
                  ),
                          type: "text",
                          inputmode: "numeric"
                        }, null, 8, ["modelValue", "validation-state", "onBlur"])
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_12,
                    _createTextVNode(),
                    _createVNode(_component_ValidationProvider, {
                      name: "勤務終了時間(分)",
                      rules: "required",
                      vid: "endTime.minutes"
                    }, {
                      default: _withCtx((validationState) => [
                        _createVNode(_component_TimeInput, {
                          modelValue: _ctx.inputValues.endTime.minutes,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValues.endTime.minutes) = $event)),
                          "validation-state": validationState,
                          max: 59,
                          onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'endTime',
                      'minutes',
                      validationState.handleChange
                    )
                  ),
                          type: "text",
                          inputmode: "numeric"
                        }, null, 8, ["modelValue", "validation-state", "onBlur"])
                      ]),
                      _: 1
                    })
                  ])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BForm, null, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                name: "休憩時間",
                vid: "hasRestValue"
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_FormRadioGroup, {
                    label: "休憩時間",
                    appLabelText: "必須",
                    name: "休憩時間",
                    modelValue: _ctx.hasRestValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hasRestValue) = $event)),
                    options: _ctx.restOptions,
                    class: "mb-3",
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "options", "validation-state"])
                ]),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          (_ctx.hasRest)
            ? (_openBlock(), _createBlock(_component_BRow, {
                key: 0,
                class: "mx-n2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ValidationProvider, {
                          name: "休憩開始時間(時)",
                          rules: "required",
                          vid: "restStartTime.hour"
                        }, {
                          default: _withCtx((validationState) => [
                            _createVNode(_component_TimeInput, {
                              modelValue: _ctx.inputValues.restStartTime.hour,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValues.restStartTime.hour) = $event)),
                              "validation-state": validationState,
                              max: 23,
                              onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'restStartTime',
                      'hour',
                      validationState.handleChange
                    )
                  ),
                              type: "text",
                              inputmode: "numeric"
                            }, null, 8, ["modelValue", "validation-state", "onBlur"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _hoisted_14,
                        _createTextVNode(),
                        _createVNode(_component_ValidationProvider, {
                          name: "休憩開始時間(分)",
                          rules: "required",
                          vid: "restStartTime.minutes"
                        }, {
                          default: _withCtx((validationState) => [
                            _createVNode(_component_TimeInput, {
                              modelValue: _ctx.inputValues.restStartTime.minutes,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValues.restStartTime.minutes) = $event)),
                              "validation-state": validationState,
                              max: 59,
                              onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'restStartTime',
                      'minutes',
                      validationState.handleChange
                    )
                  ),
                              type: "text",
                              inputmode: "numeric"
                            }, null, 8, ["modelValue", "validation-state", "onBlur"])
                          ]),
                          _: 1
                        })
                      ])
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, {
                    cols: "auto",
                    class: "px-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ValidationProvider, {
                          name: "休憩終了時間(時)",
                          rules: "required",
                          vid: "restEndTime.hour"
                        }, {
                          default: _withCtx((validationState) => [
                            _createVNode(_component_TimeInput, {
                              modelValue: _ctx.inputValues.restEndTime.hour,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputValues.restEndTime.hour) = $event)),
                              "validation-state": validationState,
                              max: 23,
                              onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'restEndTime',
                      'hour',
                      validationState.handleChange
                    )
                  ),
                              type: "text",
                              inputmode: "numeric"
                            }, null, 8, ["modelValue", "validation-state", "onBlur"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _hoisted_17,
                        _createTextVNode(),
                        _createVNode(_component_ValidationProvider, {
                          name: "休憩終了時間(分)",
                          rules: "required",
                          vid: "restEndTime.minutes"
                        }, {
                          default: _withCtx((validationState) => [
                            _createVNode(_component_TimeInput, {
                              modelValue: _ctx.inputValues.restEndTime.minutes,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputValues.restEndTime.minutes) = $event)),
                              "validation-state": validationState,
                              max: 59,
                              onBlur: ($event: any) => (
                    _ctx.onBlurTime(
                      $event,
                      'restEndTime',
                      'minutes',
                      validationState.handleChange
                    )
                  ),
                              type: "text",
                              inputmode: "numeric"
                            }, null, 8, ["modelValue", "validation-state", "onBlur"])
                          ]),
                          _: 1
                        })
                      ])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_AppButton, {
            variant: "secondary",
            block: true,
            onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton))
          }, {
            default: _withCtx(() => [
              _createTextVNode("差額を確認する")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["initialValues"])
  ]))
}